import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ConfigSystemParams, dropdownSelectAllValues } from '../../consts';
import { ConfigSystemService } from '../../services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { IdAndDescriptionDTO } from '../../interfaces/general/id-description';
import { TypesLicenceService } from '../../services/utelize/system/type/types-licence-service';

@Component({
  selector: 'app-dropdown-licence-type',
  templateUrl: './dropdown-licence-type.component.html',
  styleUrls: ['./dropdown-licence-type.component.scss']
})

export class DropdownLicenceTypeComponent implements AfterViewInit, OnInit {

  @Input() initialLicenceTypeId   : number  | undefined;
  @Input() labelOnTop             : boolean | undefined;
  @Input() retainFirstBlankOption : boolean | undefined;
  @Input() showAllSureSimCompanies: boolean | undefined;
  
  @Output() selectOnChangeEvent: EventEmitter<IdAndDescriptionDTO>=new EventEmitter<IdAndDescriptionDTO>();

  get selectAllOption() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownsProvideSelectAllOption, false ); }

  private licenceTypeIdData!: IdAndDescriptionDTO[];

  public addOrEditForm!        : UntypedFormGroup;
  public firstLicenceTypeOption: string="";
  
  constructor(
    private configSystemService: ConfigSystemService,
    private exceptionsService  : ExceptionsService,
    private formBuilder        : FormBuilder,
    private typesLicenceService: TypesLicenceService
  ) { }

  ngOnInit(): void {
    try {
      if (this.labelOnTop==undefined)
        this.labelOnTop=true;
      
      this.getDropdownData();

      let licenceTypeId          =this.initialLicenceTypeId==undefined ? 0 : this.initialLicenceTypeId;
      this.firstLicenceTypeOption=!this.retainFirstBlankOption && this.selectAllOption ? dropdownSelectAllValues.All : "";

      this.addOrEditForm=this.formBuilder.group({
        licenceTypeId: [licenceTypeId, []]
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  ngAfterViewInit(){
    try {
      this.selectOnChange(undefined);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getDropdownDataObjectArray() {
    try {
      return this.licenceTypeIdData;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
  
  private getDropdownData() {
    try {
      this.typesLicenceService.getIdAndDescription()
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.licenceTypeIdData=(data as IdAndDescriptionDTO[]);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public selectOnChange(event: Event | undefined) {
    try {
      const licenceTypeId=this.addOrEditForm.controls["licenceTypeId"].value;
      const licenceType  =this.licenceTypeIdData?.find(x => x.id==licenceTypeId);

      this.selectOnChangeEvent.emit(licenceType);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }
}
